import {Controller} from "stimulus"
import $ from 'jquery';
import {set_locale} from './localize_controller'

/*require("jquery-blockui")*/

export let blockBody = () => {
    let img = $('#loader_img')[0];

    $.blockUI({
        theme: false,
        css: {
            padding:        0,
            margin:         0,
            width:          '100%',
            top:            '0',
            left:           '0',
            textAlign:      'center',
            color:          '#000',
            border:         'none',
            backgroundColor:'#fff',
            cursor:         'none'
        },
        overlayCSS: {
            backgroundColor: '#ffffff',
            opacity: '1'
        },
        fadeIn:  800,
        message:  `<div class="loader_container">
                        <div class='loader'>
                             <div id="loader_front" class="loader-img" style="--i:url('${img.dataset.img}');"></div>
                             <div id="loader_back" class="loader-img" style="--i:url('${img.dataset.img}');"></div>
                             <div id="loader_left" class="loader-img" style="--i:url('${img.dataset.img}');"></div>
                             <div id="loader_right" class="loader-img" style="--i:url('${img.dataset.img}');"></div>
                             <div id="loader_top" class="loader-img" style="--i:url('${img.dataset.img}');"></div>
                             <div id="loader_bottom" class="loader-img" style="--i:url('${img.dataset.img}');"></div>
                        </div>
                        <div class="loader-text">${I18n.t('global.loader')}</div>
                    </div>`
    })
}

export let unblockBody = () => {
    $.unblockUI({ fadeOut: 1500 });
}

export let blockElementsById = (id, msg,background_text ='rgba(0,0,0,0)',color_text = '#0056A3',background_overlay = '#FFFFFF') => {
    let block_element = $('#'+id);

    block_element.block({
        message: `${msg}`,
        css:{
            border: 'none',
            backgroundColor: `${background_text}`,
            color: `${color_text}`,
            backdropFilter: 'blur(2px)'
        },
        overlayCSS:  {
            backgroundColor: `${background_overlay}`,
            opacity:         1,
            cursor:          'wait',
            backdropFilter: 'blur(2px)',
            borderRadius: '5px'
        },
    });
}

export let unBlockElementById = (id) => {
    let block_element = $('#'+id);
    block_element.unblock();
}

// Bloquea #blockId mientras `work` (Promise) esté en curso y GARANTIZA el desbloqueo
// en éxito, error y timeout (red de seguridad para los formularios de reserva).
//
// opts: { timeout (ms, default 90000), errorTitle, errorMessage, onError(err) }
//
// Nota: las llamadas internas (get_contract/get_tariffs/…) pueden re-bloquear el mismo
// elemento con mensajes más específicos ("Buscando contrato…"); el unblock de aquí
// solo se ejecuta al final de la cadena, en todas las ramas.
export let withElementBlock = (blockId, msg, work, opts = {}) => {
    const { timeout = 30000, errorTitle, errorMessage, onError } = opts;

    // Mismo estilo que el resto de los bloques del flujo (b2b, rentaContractModalityTariff):
    // overlay oscuro translúcido, letra blanca y spinner, en vez del blanco crudo por defecto.
    // Si el msg ya es HTML (p.ej. create_reservation con su spinner), se usa tal cual.
    const styledMessage = (typeof msg === 'string' && msg.trim().startsWith('<'))
        ? msg
        : `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${msg}</span></div>`;
    blockElementsById(blockId, styledMessage, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');

    let settled = false;
    const safety = setTimeout(() => {
        if (settled) return;
        settled = true;
        unBlockElementById(blockId);
        toastr.error(errorMessage || I18n.t('global.main.form.message.timeout_error'),
                     errorTitle || I18n.t('global.main.form.message.request_error_title'));
    }, timeout);

    return Promise.resolve(work).then(
        result => {
            clearTimeout(safety);
            if (!settled) { settled = true; unBlockElementById(blockId); }
            return result;
        },
        err => {
            clearTimeout(safety);
            if (!settled) { settled = true; unBlockElementById(blockId); }
            if (typeof onError === 'function') onError(err);
            toastr.error(errorMessage || I18n.t('global.main.form.message.request_error'),
                         errorTitle || I18n.t('global.main.form.message.request_error_title'));
            // NO re-lanzamos: los callers encadenan solo .then y ningún helper rechaza hoy.
            // Un throw aquí generaría unhandled rejection sin aportar nada al usuario.
            return undefined;
        }
    );
};

export default class extends Controller {
    connect() {
        set_locale().then(
            locale => {
                blockBody();
            }
        )
    }

    blockElement(e){
        blockElementsById(e.target.dataset.block,e.target.dataset.blockMessage);
    }
}